import React from 'react';
import { shape, string, bool, object } from 'prop-types';
import { connect } from 'react-redux';
import SafePureComponent from '../shared/SafePureComponent';
import { shouldRenderCustomOrder } from '../../utils/customOrder';
import isInCustomOrderPackageTest from '../../utils/experiments/customOrderPackage';
import { isSinglePackage } from '../../reducers/packages';
import CustomOrder from './CustomOrder';
import ContactSellerBtn from './ContactSellerBtn';

const ContactSeller = ({ customOrder, isSinglePackage }, { general, requestContext }) => {
    const { ab_tests: abTests, current_user: currentUser } = requestContext;
    const { isOnVacation } = general;
    const inCustomOrderPackageTest = isInCustomOrderPackageTest(abTests);

    const shouldRenderCustomOrderBtn = shouldRenderCustomOrder({
        customOrder,
        general,
        currentUser,
        inCustomOrderPackageTest
    });

    if (shouldRenderCustomOrderBtn && (isSinglePackage || !inCustomOrderPackageTest)) {
        return <CustomOrder/>;
    } else if (!isOnVacation && !shouldRenderCustomOrderBtn) {
        return <ContactSellerBtn/>;
    } else {
        return null;
    }
};

ContactSeller.propTypes = {
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

ContactSeller.defaultProps = {
    customOrder: {
        allowCustomOrders: true
    }
};

ContactSeller.contextTypes = {
    requestContext: object,
    general: object
};

const mapStateToProps = ({ packages }) => ({
    isSinglePackage: isSinglePackage(packages)
});

export { ContactSeller };
export default SafePureComponent(connect(mapStateToProps)(ContactSeller));
